import { IdAndNameOf } from './IApiBaseResource';
import { IApiScheduleFullView } from './IApiSchedule';
import { IApiSymbol } from './IApiSymbol';

export enum ApiSyntheticCalculationType {
  Triangulation = 'TRIANGULATION',
  Inversion = 'INVERSION',
}

interface IApiSyntheticSymbolProps {
  symbolGroup: string;
  name: string;
  calculationType: ApiSyntheticCalculationType;
  baseAsset: string;
  quoteAsset: string;
  priceDigits: number;
}

export interface IApiNewSyntheticSymbol extends IApiSyntheticSymbolProps {
  sourceSymbol1Id: IApiSymbol['id'];
  // Required for TRIANGULATION, absent for INVERSION
  sourceSymbol2Id?: IApiSymbol['id'];
  scheduleId?: IApiScheduleFullView['id'];
}

export interface IApiSyntheticSymbol extends IApiSyntheticSymbolProps {
  id: number;
  sourceSymbol1: IdAndNameOf<IApiSymbol>;
  sourceSymbol2?: IdAndNameOf<IApiSymbol>;
  schedule?: IdAndNameOf<IApiScheduleFullView>;
  updatedAt: number;
}

export interface IApiSyntheticSymbolsList {
  symbols: IApiSyntheticSymbol[];
  filteredCount: number;
  totalCount: number;
}

export interface IApiSyntheticSymbolDetails extends Omit<IApiSyntheticSymbol, 'schedule'> {
  schedule?: IApiScheduleFullView;
}
